module.exports = __webpack_public_path__ + "img/transfer0.ecd7e3d9.png";